var App = App || {};

App.SubPromoBand = (function ($) {
    "use strict";

    function init() {

        const subPromoBand = $(".widget.widget-subpromos-band");
        if (subPromoBand.length) {
            subPromoBand.each(function () {
                InitCarousels($(this));
            });
        }
    }

    function InitCarousels(subPromosBand) {
        const carouselDesktop = subPromosBand.find(".desktop-wrapper .splide");
        const carouselMobile = subPromosBand.find(".mobile-wrapper .splide");
        if (carouselDesktop.length && carouselMobile.length) {
            const splideCarouselDesktop = new Splide(carouselDesktop[0], {
                pagination: false,
                type: 'loop',
                fixedWidth: "35.0rem",
                gap: "30px",
                drag: true,
                snap: false,
                perMove: 1
            });

            const splideCarouselMobile = new Splide(carouselMobile[0], {
                pagination: false,
                type: 'slide',
                focus: "center",
                fixedWidth: "35.0rem",
                gap: "30px",
                drag: true,
                snap: false,
                perMove: 1,
                breakpoints: {
                    991: {
                        fixedWidth: "34.0rem",
                        gap: "11px",
                        trimSpace: false
                    },
                    767: {
                        fixedWidth: "25.0rem",
                        gap: "10px",
                        trimSpace: false
                    },
                }
            });

            splideCarouselDesktop.mount();

            const nextBtnDesktop = subPromosBand.find(".desktop-wrapper .carousel-btn.carousel-next");
            const prevBtnDesktop = subPromosBand.find(".desktop-wrapper .carousel-btn.carousel-prev");

            nextBtnDesktop.on("click", function () {
                splideCarouselDesktop.go('+1')
            });

            prevBtnDesktop.on("click", function () {
                splideCarouselDesktop.go('-1')
            });

            splideCarouselMobile.mount();

            const nextBtnMobile = subPromosBand.find(".mobile-wrapper .carousel-btn.carousel-next");
            const prevBtnMobile = subPromosBand.find(".mobile-wrapper .carousel-btn.carousel-prev");

            splideCarouselMobile.on("move", function () {
                disableButtons(splideCarouselMobile, nextBtnMobile, prevBtnMobile);
            });

            disableButtons(splideCarouselMobile, nextBtnMobile, prevBtnMobile);

            nextBtnMobile.on("click", function () {
                splideCarouselMobile.go('+1');
            });

            prevBtnMobile.on("click", function () {
                splideCarouselMobile.go('-1');
            });
        }
    }

    function disableButtons(splideCarouselMobile, nextBtnMobile, prevBtnMobile) {
        if (splideCarouselMobile.index == splideCarouselMobile.length - 1) {
            nextBtnMobile.addClass("disabled");
        } else {
            nextBtnMobile.removeClass("disabled")
        }
        if (splideCarouselMobile.index == 0) {
            prevBtnMobile.addClass("disabled")
        } else {
            prevBtnMobile.removeClass("disabled")

        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SubPromoBand.init();
});